module.exports = __webpack_public_path__ + "media/images/landing/dno/c-f61953ff7d130d903d5a1f616c78f5ec.png";